import React from 'react';
import { SaveButton, NextButton, ContainerButtons } from './styled';

interface FormButtonsProps {
  handlerSend: () => void;
  handlerNext: () => void;
  handlerRedirect?: () => void;
  isFinished?: boolean;
  formIsValid: boolean;
  onlySaveButton?: boolean;
}

const FormButtons = (props: FormButtonsProps) => {
  const {
    handlerSend,
    handlerNext,
    handlerRedirect,
    isFinished,
    formIsValid,
    onlySaveButton
  } = props;
  return (
    <ContainerButtons>
      <SaveButton
        disabled={!formIsValid}
        onClick={handlerSend}
        data-testid="cmp-save-bse-form"
      >
        {onlySaveButton ? 'Enviar' : 'Guardar'}
      </SaveButton>
      {!onlySaveButton && (
        <NextButton
          onClick={isFinished ? handlerRedirect : handlerNext}
          data-testid="cmp-next-bse-form"
        >
          {isFinished ? 'Finalizar' : 'Siguiente'}
        </NextButton>
      )}
    </ContainerButtons>
  );
};
FormButtons.defaultProps = {
  isFinished: false
};
export default FormButtons;
